import { Unit } from './Product';
import { SuggestionOutput } from './Suggestion';

export enum ControlType {
  FULL = 'FULL',

  SAMPLE = 'SAMPLE',
}

export enum Status {
  PLANNED = 'PLANNED',
  PAUSED = 'PAUSED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}

export enum Result {
  PASS = 'PASS',

  FAIL_T1 = 'FAIL_T1',

  FAIL_T2 = 'FAIL_T2',

  FAIL_AVG = 'FAIL_AVG',
}

export interface PackagedGoodsControl {
  id: string;

  name: string;

  controlType: ControlType;

  productId: string;

  densityGMl?: number;

  tareWeightG?: number;

  lotNumber: string;

  plannedDate?: Date;

  startDate?: Date;

  endDate?: Date;

  lotQuantity?: number;

  status: Status;

  result?: Result;

  t1Error?: number;

  controlPhase1Quantity?: number;

  controlTotalQuantity?: number;

  scaleIds?: string[];

  scales?: SuggestionOutput[];
  productName?: string;
  productQuantity?: number;
  unit?: Unit;
}
